module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event-list"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.events')))]), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('el-collapse', {
    model: {
      value: (_vm.collapse),
      callback: function($$v) {
        _vm.collapse = $$v
      },
      expression: "collapse"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$t('title.custom-filters'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('event-list-config', {
    attrs: {
      "hide-event-type-id": ""
    },
    on: {
      "filtersChanged": _vm.filtersChanged
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('event-table', {
    attrs: {
      "filters": _vm.mergedFilters,
      "showSearch": false,
      "profile": _vm.profile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20106e06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/EventList.vue
// module id = 978
// module chunks = 2